import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Select } from 'antd'

const { Option } = Select

import Input from '../../common/Input'
import css from './BusinessForm.css'

const registrationTypes = [
  'Sole Proprietorship',
  'Partnership',
  'Corporation',
  'Co-operative',
  'Limited Liability Corporation',
  'Non-profit Corporation',
]

const registrationIdentifiers = ['EIN', 'CCN']

export default class BusinessForm extends Component {
  static propTypes = {
    addOrEdit: PropTypes.func.isRequired,
    business: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      website: PropTypes.string.isRequired,
      registration_type: PropTypes.string.isRequired,
      registration_identifier: PropTypes.string.isRequired,
      registration_number: PropTypes.string.isRequired,
    }),
    businessArrayId: PropTypes.number,
    hideForm: PropTypes.func.isRequired,
  }

  static defaultProps = {
    business: null,
    businessArrayId: null,
  }

  state = {
    isLoading: false,
    name: '',
    registration_identifier: 'EIN',
    registration_number: '',
    registration_type: 'Corporation',
    website: '',
  }

  componentWillMount() {
    const { business } = this.props
    if (business) {
      const {
        isLoading,
        name,
        registration_identifier,
        registration_number,
        registration_type,
        website,
      } = business
      this.setState({
        isLoading,
        name,
        registration_identifier,
        registration_number,
        registration_type,
        website,
      })
    }
  }

  onInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.setState({
      isLoading: true,
    })
    const {
      name,
      registration_identifier,
      registration_number,
      registration_type,
      website,
    } = this.state
    const { business, addOrEdit, hideForm } = this.props
    const businessId = (business && business.id) || undefined
    addOrEdit(
      {
        name,
        website,
        registration_type,
        registration_identifier,
        registration_number,
      },
      businessId,
      this.props.businessArrayId,
    ).then(() => {
      hideForm()
    })
  }

  render() {
    return (
      <Form
        layout="horizontal"
        onSubmit={this.handleSubmit}
        className={css.form}
      >
        <div className={css.header}>
          <h3>New Business:</h3>
          <Button icon="close" onClick={this.props.hideForm} shape="circle" />
        </div>
        <Input
          key="name"
          label="Name"
          value={this.state['name']}
          name="name"
          onChange={this.onInputChange}
        />
        <Input
          key="website"
          label="Website"
          value={this.state['website']}
          name="website"
          onChange={this.onInputChange}
        />
        <Form.Item label="Registration Type" className={css.select}>
          <Select
            value={this.state.registration_type}
            name="registration_type"
            onChange={value => {
              this.setState({ registration_type: value })
            }}
          >
            {registrationTypes.map((registrationType, index) => (
              <Option key={index} value={registrationType}>
                {registrationType}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Registration Identifier" className={css.select}>
          <Select
            value={this.state.registration_identifier}
            name="registration_identifier"
            onChange={value => {
              this.setState({ registration_identifier: value })
            }}
          >
            {registrationIdentifiers.map((registrationIdentifier, index) => (
              <Option key={index} value={registrationIdentifier}>
                {registrationIdentifier}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Input
          key="registration_number"
          label="Registration Number"
          value={this.state['registration_number']}
          name="registration_number"
          onChange={this.onInputChange}
        />
        <Form.Item className={css.button}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={
              !this.state.name.trim() ||
              !this.state.website.trim() ||
              !this.state.registration_type.trim() ||
              !this.state.registration_identifier.trim() ||
              !this.state.registration_number.trim()
            }
            loading={this.state.isLoading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Practice/BusinessForm.js